package com.vectencia.klarinet

actual enum class AudioSessionCategory {
    PLAYBACK, RECORD, PLAY_AND_RECORD, AMBIENT
}
